<template>
  <div class="flex justify-between items-center uppercase font-bold"
  style="padding: 0;"
  >
    <span v-text="label" />
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
    },
  },
};
</script>
